export const SET_DARK_MODE = 'SET_DARK_MODE'
export const SET_PAGE_ID = 'SET_PAGE_ID'
export const REMOVE_PAGE_ID = 'REMOVE_PAGE_ID'
